module.exports = __webpack_public_path__ + "img/intelligentService-4.bc9957f9.png";